import { type IResolveConnectorPermissionChangedBodyProps } from "../types/notifications";
import { resolveConnectorApprovalLevelLabel } from "./connector-approval";

// NOTE: NSAI-4090 — builds the connector_permission_changed card body. Shared by
// the web drawer and the mobile screen so the two can't drift on how the org
// levels are named.
//
// Levels arrive as EConnectorApprovalLevel values (never localized text), so the
// labels are resolved here through the connectorApproval catalog — which is also
// where NEVER_ASK correctly becomes "No minimum" rather than "Never ask".
//
// NSAI-4978 — the sentence names the connector and the change only, never who
// made it. This card fans out to every org member holding the connector, so
// naming the acting admin told all of them who holds which access; the actor
// fields are gone from the payload, leaving one unconditional anonymous sentence
// instead of the old actor/anonymous pair.
export const resolveConnectorPermissionChangedBody = ({
  data,
  translate,
  translateApproval,
}: IResolveConnectorPermissionChangedBodyProps): string =>
  translate("type.connector_permission_changed.body", {
    providerLabel: data.providerLabel,
    previousLevel: resolveConnectorApprovalLevelLabel({
      translate: translateApproval,
      level: data.previousMinLevel,
    }),
    newLevel: resolveConnectorApprovalLevelLabel({
      translate: translateApproval,
      level: data.newMinLevel,
    }),
  });
